<script setup lang="ts">
import { PaybackProps } from "./Payback.props"

defineProps<PaybackProps>()
</script>

<template>
  <section
    class="
      banner-help-customer_service
      grid-container
      relative
      h-full
      px-4
      pb-[10px]
      pt-6
      md:pb-[60px]
    "
    :class="
      isCheckout
        ? 'flex flex-col overflow-hidden rounded-lg  md:mt-10 md:px-10 md:py-6 lg:px-10'
        : 'md:px-[72px] md:py-16 lg:px-[228px]'
    "
  >
    <UtilsWrapperImage
      v-if="bgImage"
      v-bind="bgImage"
      :key="bgImage.image.url"
      class="
        wrapper-image-full-container-centered
        absolute
        inset-0
        overflow-hidden
      "
      sizes="100vw sm:100vw"
    />
    <div class="text-white z-10 col-span-full md:col-span-3">
      <!-- Logo -->
      <UtilsIcon v-if="logo" v-bind="logo" class="shrink-0" />
      <p v-if="logo" class="beaver">
        {{ caption }}
      </p>
      <!-- Caption -->
      <p v-if="caption" class="beaver">
        {{ caption }}
      </p>
      <!-- Title -->
      <p v-if="title" class="md:mammoth-bold elephant-bold py-2 md:pb-5">
        {{ title }}
      </p>

      <div class="beaver md:pig pb-6">
        <!-- Text -->
        <span v-if="text">
          {{ text }}
        </span>
        <span>&nbsp;</span>
        <!-- TextLink -->
        <AppLink class="underline" v-if="textLink" :to="textLink">
          {{ $t("homepage.bannerPayback.internalLink") }}
        </AppLink>
      </div>
    </div>

    <!-- Cards List -->
    <BannerUtilityCard
      v-for="(card, index) in listPaybackCard"
      :key="`helpCard-${index}`"
      class="z-10 col-span-full mb-4 md:col-span-3"
      v-bind="card"
      theme="blue"
    />
  </section>
</template>
